import { Injectable } from '@angular/core';
import {
    IEquity,
    IFinancialLineItemComponent,
    IFli,
    IFreeTable,
    IMovementScheduleComponent,
    INotesSelectComponent,
    Notes,
} from '@modeso/types__aumico-lib-annualreport-be';
import { ComponentType } from '@modeso/types__aumico-lib-notes-be';
import { IAnnualReportDefaultSettings } from '../interfaces/IAnnualReportDefaultSettings.interface';
import { INotesAccordion } from '../interfaces/notes-accordion.interface';
import { ComponentDataSettingsUpdaterHelper } from './componentDataSettingsUpdater.helper';

@Injectable({ providedIn: 'root' })
export class NotesAccordionDataSettingsUpdaterHelper {
    private settings: IAnnualReportDefaultSettings;
    private flis: IFli[] = [];

    constructor(private componentDataSettingsUpdaterHelper: ComponentDataSettingsUpdaterHelper) {
        this.settings = undefined;
    }

    public updateCurrencyAndDatesOfAccordions(
        accordions: INotesAccordion[],
        settings: IAnnualReportDefaultSettings,
        flis: IFli[],
    ): INotesAccordion[] {
        this.settings = { ...settings };
        this.flis = [...flis];
        for (let accordion of accordions) {
            accordion = this.updateCurrencyAndDatesOfAccordion(accordion);
        }

        return accordions;
    }

    private updateCurrencyAndDatesOfAccordion(accordion: INotesAccordion): INotesAccordion {
        for (const componentData of accordion.data) {
            componentData.data = this.updateCurrencyAndDatesOfComponent(
                componentData.componentName,
                componentData.data,
            );
        }

        return accordion;
    }

    private updateCurrencyAndDatesOfComponent(componentName: ComponentType, componentData: Notes): Notes {
        switch (componentName) {
            case ComponentType.RICH_TEXT:
                return componentData;

            case ComponentType.EQUITY:
                return this.componentDataSettingsUpdaterHelper.updateCurrencyAndDatesOfEquityAndFreeTable(
                    componentData as IEquity,
                    this.settings,
                );

            case ComponentType.FINANCIAL_LINE_ITEM:
                return this.componentDataSettingsUpdaterHelper.updateCurrencyAndDatesOfFinancialLineItem(
                    componentData as IFinancialLineItemComponent,
                    this.settings,
                );

            case ComponentType.FREE_TABLE_WITH_AMOUNTS:
                return this.componentDataSettingsUpdaterHelper.updateCurrencyAndDatesOfEquityAndFreeTable(
                    componentData as IFreeTable,
                    this.settings,
                );

            case ComponentType.SELECT:
                return this.componentDataSettingsUpdaterHelper.updateCurrencyAndDatesOfSelect(
                    componentData as INotesSelectComponent,
                    this.settings,
                );

            case ComponentType.INPUT:
                return componentData;

            case ComponentType.MOVEMENT_SCHEDULE:
                return this.componentDataSettingsUpdaterHelper.updateDatesOfMovementsSchedule(
                    componentData as IMovementScheduleComponent,
                    this.settings,
                );

            case ComponentType.SUPER_TABLE:
                return componentData;

            default:
                throw new Error(`This component ${componentName} is not supported`);
        }
    }
}
